// extracted by mini-css-extract-plugin
module.exports = {"root":"Banner-module--root--V2hAh"};